module.exports = __webpack_public_path__ + "img/signup_carousel_1.0aa03d11.svg";